// A white content card on the grey canvas: same border, radius and shadow as the dashboard cards.
export const contentCardSx = {
  bgcolor: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 3,
  boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
  p: { xs: 2.5, sm: 3.5 },
};
